import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function StoreIcon(props: IconProps) {
    return <Icon {...props} iconKey={"store"}/>
}
